import React from 'react';

const FooterNotes = () => {
  return (
    <section className="footer_section footer-notes">
      <div className="container">
        <p>
          1. Verizon + Openbank Savings is offered exclusively by Openbank, a division of
          { ' ' }
          Santander Bank, N.A., and is not managed, housed, or controlled by Verizon.
          { ' ' }
          Santander Bank, N.A., offering your account through its Openbank division, is a
          { ' ' }
          Federal Deposit Insurance Corporation (“FDIC”) insured institution. Deposits at
          { ' ' }
          Santander Bank, N.A. and its Openbank division are combined for FDIC insurance purposes
          { ' ' }
          (FDIC Cert. 29950) and are not separately insured. There is a maximum of $250,000 of
          { ' ' }
          deposit insurance from the FDIC per depositor for each category of account ownership.
          { ' ' }
          Please visit fdic.gov for details. Verizon is not a chartered banking institution and
          { ' ' }
          is not insured by FDIC.
        </p>
        <p>
          The Openbank high yield savings account is a variable-rate account and the rate
          { ' ' }
          applicable may change at any time without notice. Availability for this product will
          { ' ' }
          be based on the residential zip code entered when account is opened within the online
          { ' ' }
          application process. Offer subject to change or cancellation at any time without notice.
          { ' ' }
          All account applications are subject to approval by Openbank.
        </p>
        <p>
          2. Interest Rates and Annual Percentage Yields (APYs) shown are accurate and effective as
          { ' ' }
          of 6/5/25. The products and rates we offer may vary between locations, are available in
          { ' ' }
          select markets only, and are subject to change without notice. This is a variable-rate
          { ' ' }
          account and the rate may change at any time without notice. A minimum opening deposit of
          { ' ' }
          $500 is required to open a Verizon + Openbank Savings account. Personal accounts only.
          { ' ' }
          For more information about applicable terms, refer to the Openbank Personal Deposit
          { ' ' }
          Account Agreement and Verizon Addendum.
        </p>
        <p>
          3. To get $180 in Verizon + Openbank Bill Credits your Verizon account must have an
          { ' ' }
          Openbank high yield savings account opened through the Verizon + Openbank Savings
          { ' ' }
          program that maintains a monthly average daily balance equal to or greater than $30,000
          { ' ' }
          for all 12 months you are eligible to earn the Verizon + Openbank Bill Credit.
        </p>
        <p>
          4. <b>Verizon + Openbank Bill Credit Eligibility and Calculation</b>:
          { ' ' }
          Eligible customers must
          { ' ' }
          have a mobile telephone number associated with a post-paid consumer wireless account
          { ' ' }
          offered by Verizon within the United States (the “Verizon Account”). To receive a credit
          { ' ' }
          on your Verizon bill (the “Verizon + Openbank Bill Credit”), you must submit an
          { ' ' }
          application for an Openbank high yield savings account (the “Deposit Account”) using
          { ' ' }
          the application link provided on Verizon’s website or mobile app. The amount of the
          { ' ' }
          Verizon + Openbank Bill Credit will be determined as follows: · $5 per month for an
          { ' ' }
          average Deposit Account balance between $1,000 and $9,999.99 for up to 12 consecutive
          { ' ' }
          months from the date your Deposit Account is opened; · $10 per month for an average
          { ' ' }
          Deposit Account balance between $10,000 and $29,999.99 for up to 12 consecutive months
          { ' ' }
          from the date your Deposit Account is opened; and · $15 per month for an average Deposit
          { ' ' }
          Account balance equal to or greater than $30,000 for up to 12 consecutive months from
          { ' ' }
          the date your Deposit Account is opened.
        </p>
        <p>
          The monthly average Deposit Account balance will be calculated on your Deposit Account
          { ' ' }
          statement date (once every month) and is mathematically derived as a daily average.
          { ' ' }
          If you do not maintain a qualifying Deposit Account balance in any given month, you will
          { ' ' }
          not receive a Verizon + Openbank Bill Credit for that month, but there will be no impact
          { ' ' }
          on your customer status or interest rate with Openbank. You may not be eligible for a
          { ' ' }
          Verizon + Openbank Bill Credit after 12 months from the date your Deposit Account is
          { ' ' }
          opened. If your Deposit Account or Verizon Account closes for any reason, or if the
          { ' ' }
          mobile telephone number associated with your Verizon Account is terminated, you will
          { ' ' }
          not be eligible for a full or partial Verizon + Openbank Bill Credit for that month
          { ' ' }
          or any future month.
        </p>
        <p>
          <b>Multiple Accounts</b>: If you have more than one Deposit Account, you are only
          { ' ' }
          eligible to receive a Verizon + Openbank Bill Credit as to the first Deposit
          { ' ' }
          Account you open. If other individuals on your Verizon Account also maintain Deposit
          { ' ' }
          Accounts, the Verizon + Openbank Bill Credit will be applied only as to the first two
          { ' ' }
          individuals to open a Deposit Account. In any event, a maximum of two Verizon + Openbank
          { ' ' }
          Bill Credits may be applied to any Verizon Account. The maximum Verizon + Openbank Bill
          { ' ' }
          Credit obtainable is with two (2) accounts, each with minimum $30,000 average balances,
          { ' ' }
          resulting in a combined bill credit of $30 monthly, totaling $360 over 12 months.
        </p>
        <p>
          <b>Verizon + Openbank Bill Credit Application</b>: If you qualify for a
          { ' ' }
          Verizon + Openbank Bill
          { ' ' }
          Credit, the Verizon + Openbank Bill Credit will be applied to your Verizon bill beginning
          { ' ' }
          within 2-3 Verizon bill cycles following the issuance of your initial Deposit Account
          { ' ' }
          statement. Verizon is solely responsible for applying the Verizon + Openbank Bill Credit
          { ' ' }
          based on Deposit Account balance information provided by Openbank.
        </p>
        <p>
          5. The APY comparison is based upon the national average for ‘Savings’ deposit
          { ' ' }
          products as published in the FDIC National Rates and Rate Caps on FDIC.gov of 0.38%,
          { ' ' }
          accurate as of 6/16/25.
        </p>
        <p>
          ©2025 Santander Bank, N.A. All rights reserved. Openbank is a division of Santander Bank,
          { ' ' }
          N.A. Openbank, Santander, and the Flame logo are trademarks of Banco Santander, S.A.
          { ' ' }
          or its subsidiaries in the United States or other countries. All other trademarks are
          { ' ' }
          the property of their respective owners.
        </p>
      </div>
    </section>
  );
};

export default FooterNotes;
